var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white rounded"},[_c('div',{staticClass:"text-left title-grey border h5 p-3 title-rounded font-weight-bold"},[_vm._v(_vm._s(_vm.subTitle))]),_c('div',{staticClass:"text-intent pl-3 pr-3 pt-4 pb-4",domProps:{"innerHTML":_vm._s(_vm.subContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }